// В params снекбара указывается:
// title - текст снекбара
// lifeTime - время жизни снекбара в секундах
// actionText - текст на кнопке снекбара
// isInfinite - Снекбар не пропадает по таймеру

// Глобальные методы this.$snackbar доступны только на этапе mounted
// В created они будут undefined

import dayjs from 'dayjs';
import Vue from 'vue';

export default {
  name: 'Snackbar',
  props: {
    // Внутренний отступ для контейнера снекбаров
    offsetY: {
      type: Number,
      default: 30,
    },
    offsetX: {
      type: Number,
      default: 30,
    },
    // Расположение снекбаров
    position: {
      type: String,
      default: 'top-left',
      validator(value) {
        return ['top-left', 'bottom-left'].includes(value);
      },
    },
    // максимальное количество снекбаров на странице
    limit: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      list: [], // Список снекбаров
      counter: 0, // Инкремент-id для снекбаров
      clearTimer: null, // Таймер удаления снекбаров. Очищается при уничтожении компонента
      defaultLifeTime: 10, // Время жизни снекбара в секундах
      defaultActionText: 'OK',
    };
  },
  computed: {
    itemOffsetStyles() {
      try {
        const X = `width: calc(100% - ${this.offsetX * 2}px); margin-left: ${this.offsetX}px;`;
        const Y = `padding-top: ${this.offsetY}px; padding-bottom: ${this.offsetY}px;`;
        return `${X} ${Y}`;
      } catch (e) {
        console.error(e);
      }
      // return `padding: ${this.containerPadding}`;
    },
  },
  mounted() {
    this.setClearSnackbarsTimer();
    this.registerGlobalProp();
  },
  beforeDestroy() {
    // Уничтожить таймер удаления просроченных снекбаров
    clearInterval(this.clearTimer);
  },
  methods: {
    // Глобальное свойство регистрируется в момент создания компонента
    // Я не использую plugins для простоты интеграции в рамках ui-kit.
    // При текущем подходе для добавления снекбара не нужно писать
    // никакой внешней логики - нужно просто добавить его в лейаут приложения
    registerGlobalProp() {
      Vue.prototype.$snackbar = {
        replace: this.replace,
        add: this.add,
        remove: this.remove,
        getList: this.getList,
      };
    },
    /**
     * Таймер, удаляющий просроченные снекбары
     */
    setClearSnackbarsTimer() {
      // Каждую секунду проверяем, какие снекбары просрочены
      // и должны быть убраны со страницы
      this.clearTimer = setInterval(() => {
        for (let i = 0; i < this.list.length; i++) {
          const item = this.list[i];

          // Бесконечные снекбары не удаляются по таймеру
          const isInfinite = item.isInfinite;
          if (isInfinite) continue;

          const createdAt = dayjs(item.createdAt);
          const lifeTime = item.lifeTime;

          const currentDate = dayjs();
          const expireAt = createdAt.add(lifeTime, 'seconds');
          const isExpired = currentDate > expireAt;

          if (isExpired) this.remove(item.id);
        }
      }, 1000);
    },
    /**
     * Метод используется для отображения только одного снекбара одновременно
     * При вызове удаляет все снекбары и устанавливает видимым только новый
     */
    replace(params) {
      const item = this.create(params);
      if (!item) return;

      this.list = [item];
    },
    /**
     * Метод используется для отображения нескольких снекбаров
     */
    add(params) {
      const item = this.create(params);
      if (!item) return;

      // Ограничить количество снекбаров лимитом
      if (this.list.length >= this.limit) this.list.splice(0, 1);

      this.list.push(item);
    },
    /**
     * Удалить снекбар по id
     */
    remove(id) {
      const index = this.list.findIndex(i => i.id === id);
      if (index === -1) return;

      this.list.splice(index, 1);
    },
    /**
     * Создать айтем снекбара. Не помещает его на страницу
     */
    create(params) {
      if (!params) {
        console.error('Snackbar params must be provided');
        return;
      }

      // Текст снекбара обязательно должен быть заполнен
      if (!params.title) {
        console.error('Snackbar title must be provided');
        return;
      }

      // Инкремент-id для снекбаров
      const id = this.counter++;
      // Запоминаем время создания снекбара, чтобы его потом удалить
      const createdAt = new Date();

      return { lifeTime: this.defaultLifeTime, actionText: this.defaultActionText, id, ...params, createdAt };
    },
    /**
     * Коллбек нажатия на экшен
     */
    onClick(id) {
      // При клике на экшен - закрываем снекбар
      this.remove(id);
    },
    /**
     * Внешняя функция-геттер на случай, если нужно получить список всех активных
     * снекбаров извне
     * ИСПОЛЬУЕТСЯ В JEST ТЕСТАХ
     */
    getList() {
      return this.list;
    },
  },
};
